export default {
  baseUrl: process.env.NODE_ENV === 'development' ? 'https://localhost:44334/' : '/site/' // 测试环境
  // baseUrl: '/site/' // 相同域下，不区分环境
  // baseUrl: 'https://forecast-uat.gileadchina.cn/site/' // 客户Uat环境
  // baseUrl: 'https://forecast.gileadchina.cn/site/' // 客户生产环境
}



// WEBPACK FOOTER //
// ./src/assets/js/pubilshSet.js